import React from "react";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate
import bgImage from "../assets/images/bg.jpeg";
import "../styles/auth.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate(); // Initialize navigate hook

  const today = new Date().toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div
      className="privacy-page"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "60px 20px 140px 20px",
      }}
    >
      <div
        className="content-container p-5 rounded"
        style={{
          width: "95%",
          maxWidth: "1000px",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          border: "3px solid #000",
          position: "relative", // Added for button positioning
        }}
      >
        {/* Go Back Button */}
        <button
          onClick={() => navigate('/')}
          className="btn btn-dark"
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            fontWeight: "700",
            textTransform: "uppercase",
            fontSize: "0.8rem",
            padding: "5px 15px",
            borderRadius: "0",
            border: "2px solid #000"
          }}
        >
          Go Back
        </button>

        <h1
          className="text-center mb-2"
          style={{
            color: "#000",
            fontWeight: "900",
            fontSize: "2.5rem",
          }}
        >
          Privacy Policy
        </h1>
         <h2  className="text-center mb-4" style={{ color: '#000', fontWeight: '700', fontSize: '1.5rem', textTransform: 'uppercase' }}>
            Blessed Builders – Sober Living Management Platform
          </h2>

       
       <div style={{ color: "#000", lineHeight: "1.8" }}>
  <p style={{ fontWeight: "700", fontSize: "1.1rem" }}>
    <strong>Effective Date:</strong> {today}
  </p>

  {/* 1. Introduction */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>1. Introduction</h4>
    <p style={{ fontWeight: "700" }}>
      Welcome to Blessed Builders Sober Living Homes (“we,” “our,” or “us”).
      We are committed to protecting your privacy and safeguarding your
      personal information.
      <br /><br />
      This Privacy Policy explains how we collect, use, disclose, and protect
      your information when you use our website and mobile application:
      <br />
      https://blessedbuilderssoberliving.org/
      <br /><br />
      By using our services, you agree to the terms of this Privacy Policy.
    </p>
  </section>

  {/* 2. Information We Collect */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>2. Information We Collect</h4>

    <p style={{ fontWeight: "700" }}>a. Personal Information</p>
    <ul>
      <li>Full name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Mailing address</li>
      <li>Date of birth</li>
      <li>Emergency contact information</li>
    </ul>

    <p style={{ fontWeight: "700" }}>b. Sensitive Information</p>
    <ul>
      <li>Substance use history</li>
      <li>Medical or mental health information</li>
      <li>Medication details</li>
      <li>Criminal or legal history</li>
    </ul>

    <p style={{ fontWeight: "700" }}>c. Location Data</p>
    <ul>
      <li>Real-time GPS location</li>
      <li>Background location (if enabled)</li>
    </ul>
    <p>
      We may collect precise and/or approximate location data from users of
      our mobile application.
    </p>

    <p style={{ fontWeight: "700" }}>d. Automatically Collected Information</p>
    <ul>
      <li>IP address</li>
      <li>Browser type</li>
      <li>Device information</li>
      <li>Pages visited and time spent</li>
    </ul>
  </section>

  {/* 3. How We Use Your Information */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>3. How We Use Your Information</h4>
    <ul>
      <li>Process applications for sober living programs</li>
      <li>Communicate with you about services and inquiries</li>
      <li>Provide support and recovery-related services</li>
      <li>Monitor resident safety and compliance</li>
      <li>Improve our website, app, and user experience</li>
      <li>Comply with legal and regulatory requirements</li>
    </ul>
  </section>

  {/* 4. Use of Location Data */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>4. Use of Location Data</h4>
    <ul>
      <li>Monitoring safety and well-being of residents</li>
      <li>Ensuring compliance with program rules</li>
      <li>Allowing authorized staff to track residents</li>
      <li>Responding to emergencies</li>
    </ul>
    <p>
      <strong>Important:</strong>
    </p>
    <ul>
      <li>Accessible only to authorized personnel</li>
      <li>Not used for advertising or marketing</li>
      <li>Collected only with user consent and device permissions</li>
    </ul>
  </section>

  {/* 5. Sharing */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>5. Sharing of Information</h4>
    <p>We do not sell your personal information.</p>
    <ul>
      <li>Staff, mentors, and program coordinators</li>
      <li>Healthcare providers or counselors (when necessary)</li>
      <li>Government or legal authorities (if required by law)</li>
      <li>Service providers assisting with operations</li>
      <li>
        Location data may be shared internally with authorized personnel for
        safety and operational purposes
      </li>
    </ul>
  </section>

  {/* 6. Security */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>6. Data Security</h4>
    <p>
      We implement reasonable administrative, technical, and physical
      safeguards to protect your information. However, no method of
      transmission over the internet is 100% secure.
    </p>
  </section>

  {/* 7. Confidentiality */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>
      7. Confidentiality & Recovery Environment
    </h4>
    <ul>
      <li>Information may be shared internally for safety and recovery support</li>
      <li>Monitoring measures (such as cameras in common areas) may be used</li>
    </ul>
  </section>

  {/* 8. Cookies */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>
      8. Cookies & Tracking Technologies
    </h4>
    <p>
      We may use cookies and similar technologies to improve functionality and
      analyze usage. You can disable cookies through your browser settings.
    </p>
  </section>

  {/* 9. Third Party */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>9. Third-Party Links</h4>
    <p>
      Our services may contain links to third-party websites. We are not
      responsible for their privacy practices.
    </p>
  </section>

  {/* 10. Rights */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>10. Your Rights</h4>
    <ul>
      <li>Access your personal data</li>
      <li>Request correction or deletion</li>
      <li>Withdraw consent (including location permissions)</li>
    </ul>
  </section>

  {/* 11. Retention */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>11. Data Retention</h4>
    <p>
      We retain your information only as long as necessary to provide services
      and comply with legal obligations.
    </p>
    <p>
      Location data is retained only as long as required for safety and
      operational purposes.
    </p>
  </section>

  {/* 12. Children */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>12. Children’s Privacy</h4>
    <p>
      Our services are intended for individuals aged 18 and above. We do not
      knowingly collect information from minors.
    </p>
  </section>

  {/* 13. Changes */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>
      13. Changes to This Policy
    </h4>
    <p>
      We may update this Privacy Policy periodically. Updates will be posted
      with a revised effective date.
    </p>
  </section>

  {/* 14. Contact */}
  <section className="mb-4">
    <h4 style={{ fontWeight: "900" }}>14. Contact Us</h4>
    <p>
      Blessed Builders Sober Living Homes
      <br />
      Address: 2700 State St. Ste F-6, Bismarck, ND 58503
      <br />
      Phone: 701-751-0318
    </p>
  </section>
</div>


      </div>

      {/* Footer Links */}
      <div className="login-footer-links w-100 text-center mt-5">
        <div className="d-flex justify-content-center align-items-center gap-2">
          <a
            href="https://blessedbuilderssoberliving.org/about-us"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            About Us
          </a>
          <span>|</span>
          <a
            href="https://blessedbuilderssoberliving.org/contact-us"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
          <span>|</span>
          <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>

          <span>|</span>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;